import type { Node, NodeProps } from "@xyflow/react";

import { Badge } from "@/components/ui/badge";
import { BADGE_TONES } from "@/lib/badge-tones";
import { formatCurrency } from "@/lib/format";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle, RightSourceHandle } from "./shared";
import type { OrderItemNodeData } from "./types";

type OrderItemFlowNode = Node<OrderItemNodeData, "orderItem">;

export function OrderItemNode({ data }: NodeProps<OrderItemFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <RightSourceHandle />
      <FlowNodeCard
        title="Order Item"
        rightSlot={
          data.isContracted ? (
            <Badge variant="outline" className={BADGE_TONES.indigo}>
              Contracted
            </Badge>
          ) : null
        }
      >
        <p className="text-sm font-semibold">{data.productName || "Unknown product"}</p>
        <FlowNodeRow label="Quantity" value={data.quantity ?? "-"} />
        <FlowNodeRow
          label="Unit Price"
          value={typeof data.unitPrice === "number" ? formatCurrency(data.unitPrice) : "-"}
        />
      </FlowNodeCard>
    </>
  );
}
